import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "@/components/layouts/ConfirmationModal";

const TRANSLATION_KEY = "chat.scheduleModal";

interface RemoveScheduleConfirmationModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => void;
}

const RemoveScheduleConfirmationModal: React.FC<
  RemoveScheduleConfirmationModalProps
> = ({ isOpen, setIsOpen, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t(`${TRANSLATION_KEY}.removeConfirmTitle`)}
      confirmationText={t(`${TRANSLATION_KEY}.removeConfirmBody`)}
      submitButtonText={t(`${TRANSLATION_KEY}.removeConfirmSubmit`)}
      handleSubmit={() => {
        setIsOpen(false);
        onConfirm();
      }}
      data-test="remove-schedule-confirmation"
    />
  );
};

export default RemoveScheduleConfirmationModal;
